import { Component } from '@angular/core';
import { StatusCheckStep } from "../../components/steps/status-check-step/status-check-step";

@Component({
  selector: 'app-membership-form',
  standalone: true,
  imports: [StatusCheckStep],
  templateUrl: './membership-form.html',
  styleUrl: './membership-form.css',
})
export class MembershipForm {
  printStatus(): void {
    window.print();
  }
}
